var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-balsa-svg",staticStyle:{"width":"65px","height":"24px"},attrs:{"name":"balsa","src":require("../assets/images/icons/balsa.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }